// Load CSS
import './scss/main.scss';

// Import
import { isQuiz, onReady } from './js/utilities';
import QuizComparisons from './js/quiz-comparison';

// Invoke classes when the DOM is ready
onReady(() => {
	// Check if the current page is a quiz
	if ( isQuiz() ){
		new QuizComparisons();
	}
});